import {useOS} from '@aboutyou/utils';
import {usePreventScroll} from 'react-aria';
import {useIsomorphicLayoutEffect} from '../useIsomorphicLayoutEffect/useIsomorphicLayoutEffect';

export const useLockBodyScroll = ({lockScroll}: {lockScroll: boolean}) => {
  const isAndroid = useOS() === 'android';

  // To address the issue where sometimes the page is not scrollable in Chrome for Android
  // after changing the body overflow style, we keep the body overflow to auto.
  // Overflow hidden is still set on the html element by usePreventScroll to prevent the page from scrolling.
  useIsomorphicLayoutEffect(() => {
    if (isAndroid) {
      document.body.style.overflow = 'auto';
    }
  }, [lockScroll]);

  usePreventScroll({isDisabled: !lockScroll});
};
